import { ProductRegistrationFormDataProps } from "./index"

export async function handleFormSubmission(
  data: ProductRegistrationFormDataProps,
  contactEmail: string
) {
  const formData = { ...data, contactEmail }
  const { recaptcha, ...formInput } = formData

  try {
    const response = await fetch("/api/registration", {
      method: "POST",
      body: JSON.stringify(formInput),
    })
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
